import { useEffect, useState } from "react";
import PLAN_URL from "../../../utils/PLAN_URL";
import axios from "axios";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  IconButton,
  InputAdornment,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

function StockInModal({ open, onClose, openSnackbar, setUpdateStatus }) {
  const { group_code, project_code } = useParams();
  const [items, setItems] = useState([]);
  const [locations, setLocations] = useState([]);
  const [formData, setFormData] = useState({
    item_code: "",
    lot_code: "",
    quantity: "",
    location_code: "",
    date: dayjs(),
  });
  const [errors, setErrors] = useState({
    item_code: "",
    lot_code: "",
    quantity: "",
    location_code: "",
  });
  useEffect(() => {
    async function fetchData() {
      try {
        const itemRes = await axios.get(
          PLAN_URL +
            `/api/item/getAllItems?group_code=${group_code}&project_code=${project_code}`
        );
        const locationRes = await axios.get(
          PLAN_URL +
            `/api/stock/getLocationM?group_code=${group_code}&project_code=${project_code}`
        );
        setItems(itemRes.data || []);
        setLocations(locationRes.data || []);
      } catch (e) {
        console.log(e);
        openSnackbar("데이터를 불러오지 못했습니다.", "error");
      }
    }
    if (open) {
      fetchData();
    }
  }, [open, group_code, project_code, openSnackbar]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    validateField(name, value);
  };
  const handleItemChange = (event, newValue) => {
    setFormData({
      ...formData,
      item_code: newValue ? newValue.item_code : "",
    });
    validateField("item_code", newValue ? newValue.item_code : "");
  };
  const handleLocationChange = (event, newValue) => {
    setFormData({
      ...formData,
      location_code: newValue ? newValue.location_code : "",
    });
    validateField("location_code", newValue ? newValue.location_code : "");
  };
  const handleDateChange = (newDate) => {
    setFormData({
      ...formData,
      date: newDate,
    });
  };
  const validateField = (name, value) => {
    let errorMessage = "";
    switch (name) {
      case "item_code":
        errorMessage = value ? "" : "제품 코드를 선택해주세요.";
        break;
      case "lot_code":
        errorMessage = value ? "" : "Lot 코드를 입력해주세요.";
        break;
      case "quantity":
        if (!value) {
          errorMessage = "수량을 입력해주세요.";
        } else if (
          isNaN(value) ||
          parseInt(value) <= 0 ||
          !Number.isInteger(Number(value))
        ) {
          errorMessage = "수량은 0보다 큰 정수여야 합니다.";
        }
        break;
      case "location_code":
        errorMessage = value ? "" : "위치 코드를 선택해주세요.";
        break;
      default:
        break;
    }
    setErrors({
      ...errors,
      [name]: errorMessage,
    });

    return errorMessage === "";
  };
  const validateForm = () => {
    const validItem = validateField("item_code", formData.item_code);
    const validLot = validateField("lot_code", formData.lot_code);
    const validQuantity = validateField("quantity", formData.quantity);
    const validLocation = validateField(
      "location_code",
      formData.location_code
    );
    return validItem && validLot && validQuantity && validLocation;
  };
  const handleSubmit = async () => {
    try {
      if (validateForm()) {
        const param = [
          group_code,
          project_code,
          formData.item_code,
          formData.lot_code,
          parseInt(formData.quantity),
          formData.location_code,
          formData.date.format("YYYY-MM-DD HH:mm:ss"),
        ];
        const res = await axios.post(
          PLAN_URL + "/api/stock/postStockIn",
          param
        );
        if (res.status === 200) {
          openSnackbar("입고 정보가 등록되었습니다.", "success");
          handleClose();
          setUpdateStatus((prev) => !prev);
        }
      } else {
        openSnackbar("입력 내용을 확인해주세요.", "error");
      }
    } catch (e) {
      console.log(e);
      openSnackbar("오류가 발생했습니다.", "error");
    }
  };
  const handleClose = () => {
    setFormData({
      item_code: "",
      lot_code: "",
      quantity: "",
      location_code: "",
      date: dayjs(),
    });
    setErrors({
      item_code: "",
      lot_code: "",
      quantity: "",
      location_code: "",
    });
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="stock-in-modal-title"
      aria-describedby="stock-in-modal-description"
    >
      <Box sx={modalStyle}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography id="stock-in-modal-title" variant="h6" component="h2">
            입고 등록
          </Typography>
          {/* <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton> */}
        </Box>
        <Grid container spacing={2}>
          {/* 제품 코드 */}
          <Grid item xs={12}>
            <Autocomplete
              id="item-select"
              options={items}
              getOptionLabel={(option) =>
                `${option.item_code} - ${option.item_name}`
              }
              onChange={handleItemChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="제품 코드"
                  name="item_code"
                  error={!!errors.item_code}
                  helperText={errors.item_code}
                  fullWidth
                  required
                />
              )}
            />
          </Grid>
          {/* Lot 코드 */}
          <Grid item xs={12}>
            <TextField
              label="Lot 코드"
              name="lot_code"
              value={formData.lot_code}
              onChange={handleChange}
              error={!!errors.lot_code}
              helperText={errors.lot_code}
              fullWidth
              required
            />
          </Grid>
          {/* 수량 */}
          <Grid item xs={12}>
            <TextField
              label="수량"
              name="quantity"
              type="number"
              value={formData.quantity}
              onChange={handleChange}
              error={!!errors.quantity}
              helperText={errors.quantity}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">EA</InputAdornment>
                ),
              }}
              fullWidth
              required
              inputProps={{
                min: 1,
                step: 1,
              }}
            />
          </Grid>
          {/* 위치 코드 */}
          <Grid item xs={12}>
            <Autocomplete
              id="location-select"
              options={locations}
              getOptionLabel={(option) =>
                `${option.location_code} - ${option.location_name}`
              }
              onChange={handleLocationChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="위치 코드"
                  name="location_code"
                  error={!!errors.location_code}
                  helperText={errors.location_code}
                  fullWidth
                  required
                />
              )}
            />
          </Grid>
          {/* 날짜 및 시간 */}
          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <MobileDateTimePicker
                label="입고 일시"
                value={formData.date}
                onChange={handleDateChange}
                renderInput={(params) => <TextField {...params} fullWidth />}
                sx={{ width: "100%" }}
              />
            </LocalizationProvider>
          </Grid>
          {/* 버튼 영역 */}
          <Grid item xs={12} mt={2} display="flex" justifyContent="flex-end">
            <Button variant="outlined" onClick={handleClose} sx={{ mr: 1 }}>
              취소
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              sx={{
                bgcolor: "#1976d2",
                "&:hover": {
                  bgcolor: "#1565c0",
                },
              }}
            >
              등록
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default StockInModal;
